import { render, staticRenderFns } from "./ondoorOrders.vue?vue&type=template&id=46e0217f&scoped=true"
import script from "./ondoorOrders.vue?vue&type=script&lang=js"
export * from "./ondoorOrders.vue?vue&type=script&lang=js"
import style0 from "./ondoorOrders.vue?vue&type=style&index=0&id=46e0217f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e0217f",
  null
  
)

export default component.exports